import React from "react";
import SEO from "../components/SEO";

const Request = () => {
  return (
    <>
      <SEO
        title='Request'
        description='Blank Beanies'
        keywords='Blank Beanies'
      />
      <div className="relative bg-gradient-to-br from-green-50 via-white to-green-100 min-h-screen">
        {/* Decorative Blobs */}
        <div className="absolute top-0 left-0 w-72 h-72 bg-[#369a74]/20 rounded-full blur-3xl -z-10" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#369a74]/20 rounded-full blur-3xl -z-10" />

        <div className="container mx-auto px-4 py-20 max-w-5xl">
          {/* Header */}
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-5xl font-extrabold text-[#369a74]">
              Customer Data Request
            </h1>
            <p className="mt-4 text-gray-700 max-w-3xl mx-auto text-lg leading-relaxed">
              Learn how to access, update, or delete your personal data with <span className="font-semibold">Personalised Patches For Hats</span>.
            </p>
          </div>

          {/* Content Card */}
          <div className="bg-white/90 backdrop-blur-xl rounded-3xl shadow-2xl border border-gray-200 p-10 md:p-12 space-y-12">

            {[
              {
                title: "Your Cookie Consent",
                content: (
                  <>
                    <p className="mb-2">
                      Consent date: <span className="font-medium">Tuesday 8 July 2025 at 19:07:20 GMT+5</span>
                    </p>
                    <p className="mb-2">Consent preference:</p>
                    <ul className="list-disc pl-6 space-y-1 text-gray-700">
                      <li>✓ Strictly necessary cookies</li>
                      <li>✓ Functional cookies</li>
                      <li>✓ Performance cookies</li>
                      <li>✓ Targeting cookies</li>
                    </ul>
                  </>
                ),
              },
              {
                title: "Data Portability",
                content: (
                  <p>
                    You have the right to request access to your personal data at any time.
                  </p>
                ),
              },
              {
                title: "Data Rectification",
                content: (
                  <p>
                    You have the right to request your data be updated whenever necessary.
                  </p>
                ),
              },
              {
                title: "Right to be Forgotten",
                content: (
                  <p>
                    You have the right to request all your personal data be erased. After that, you will no longer be able to access your account.
                  </p>
                ),
              },
            ].map((section, idx) => (
              <section
                key={idx}
                className="relative pl-6 group hover:bg-[#369a74]/10 transition-all duration-300 rounded-xl p-4"
              >
                <div className="absolute left-0 top-2 h-full w-1 rounded-full bg-gradient-to-b from-[#369a74] to-[#32c499] group-hover:scale-110 transition-transform" />
                <h2 className="text-2xl font-bold text-[#369a74] mb-4">
                  {section.title}
                </h2>
                <div className="text-gray-700 leading-relaxed text-base">
                  {section.content}
                </div>
              </section>
            ))}

            {/* Contact */}
            <section className="border-t pt-8 text-center">
              <h2 className="text-2xl font-bold text-[#369a74] mb-4">
                Contact Us
              </h2>
              <p className="text-gray-700 mb-4">
                If you have any questions regarding your data rights or requests, please contact us:
              </p>
              <div className="mt-4 text-gray-700">
                <p className="font-semibold text-[#369a74]">Personalised Patches For Hats</p>
                <p>Email: support@personalisedpatchesforhats.com</p>
                <p>Phone: (703) 666-8193</p>
              </div>
            </section>

            {/* Footer */}
            <p className="text-sm text-gray-500 text-center pt-6 border-t">
              Last updated: 07/08/2025
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Request;
